import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, clearTokens } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const [site, setSite] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/session");
      if (!data.user) clearTokens();
      setUser(data.user || false);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    api.get("/settings/public").then((r) => setSite(r.data)).catch(() => {});
  }, [refresh]);

  const login = async (phone, password) => {
    const { data } = await api.post("/auth/login", { phone, password });
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    clearTokens();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh, site }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
